export const adminStyles = {
  page: {
    height: "100dvh",
    background: "var(--page-bg)",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  shell: {
    width: "100%",
    height: "100dvh",
    display: "flex",
    alignItems: "stretch",
    minHeight: 0,
    minWidth: 0,
  },
  content: {
    flex: "1 1 auto",
    height: "100dvh",
    minWidth: 0,
    minHeight: 0,
    overflow: "hidden",
    padding: "var(--admin-content-padding)",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: "var(--admin-gap)",
  },
  contentHeader: {
    flexShrink: 0,
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: "var(--admin-control-height)",
  },
  contentTitle: {
    margin: 0,
    fontSize: "var(--admin-title-size)",
    fontWeight: 800,
    color: "var(--text-main)",
    lineHeight: 1.2,
  },
  contentDescription: {
    margin: "3px 0 0",
    color: "var(--text-muted)",
    fontSize: "var(--admin-text-xs)",
    lineHeight: 1.35,
  },
  fixedTop: {
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    gap: "var(--admin-gap)",
    position: "relative",
    zIndex: 5,
  },
  topBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "var(--admin-gap-lg)",
    minWidth: 0,
    flexWrap: "wrap",
  },
  topTitleBlock: {
    minWidth: 0,
    flex: "1 1 auto",
  },
  title: {
    margin: 0,
    fontSize: "var(--admin-title-size)",
    fontWeight: 800,
    color: "var(--text-main)",
    whiteSpace: "nowrap",
  },
  subtitle: {
    margin: "3px 0 0",
    color: "var(--text-muted)",
    fontSize: "var(--admin-text-sm)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  topActions: {
    display: "flex",
    alignItems: "center",
    gap: "var(--admin-gap-sm)",
    flex: "0 0 auto",
    flexWrap: "nowrap",
  },
  addButton: {
    border: "none",
    background: "var(--accent)",
    color: "var(--button-text)",
    padding: "var(--admin-button-padding-y) var(--admin-button-padding-x)",
    borderRadius: "var(--admin-radius)",
    fontWeight: 700,
    fontSize: "var(--admin-text-sm)",
    cursor: "pointer",
    lineHeight: 1,
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  card: {
    background: "var(--card-bg)",
    borderRadius: "var(--admin-card-radius)",
    border: "1px solid var(--border)",
    borderTop: "4px solid var(--accent)",
    boxShadow: "var(--shadow-panel)",
    padding: "var(--admin-card-padding)",
  },
  documentsCard: {
    flex: "1 1 0",
    minHeight: 0,
    background: "var(--card-bg)",
    borderRadius: "var(--admin-card-radius)",
    border: "1px solid var(--border)",
    boxShadow: "var(--shadow-panel)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  placeholderCard: {
    flex: "1 1 auto",
    minHeight: 0,
    background: "var(--card-bg)",
    borderRadius: "var(--admin-card-radius)",
    border: "1px solid var(--border)",
    boxShadow: "var(--shadow-panel)",
    padding: "var(--admin-card-padding)",
    boxSizing: "border-box",
  },
  placeholderTitle: {
    margin: 0,
    color: "var(--text-main)",
    fontSize: "var(--admin-heading-size)",
    fontWeight: 800,
  },
  placeholderText: {
    margin: "8px 0 0",
    color: "var(--text-muted)",
    fontSize: "var(--admin-text)",
    lineHeight: 1.5,
  },
  documentsHeader: {
    flexShrink: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "var(--admin-gap-lg)",
    padding: "var(--admin-gap) var(--admin-card-padding)",
    borderBottom: "1px solid var(--border)",
    background: "var(--card-bg-soft)",
  },
  documentsTitle: {
    margin: 0,
    color: "var(--text-main)",
    fontSize: "var(--admin-text)",
    fontWeight: 800,
  },
  documentsScroll: {
    flex: "1 1 auto",
    minHeight: 0,
    overflowY: "auto",
    overflowX: "auto",
  },
  controls: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "var(--admin-gap-sm)",
    marginBottom: "var(--admin-gap-sm)",
  },
  filterActionsBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "var(--admin-gap)",
    marginBottom: "var(--admin-gap-sm)",
    flexWrap: "wrap",
  },
  fieldSearchGroup: {
    display: "flex",
    alignItems: "center",
    gap: "var(--admin-gap-sm)",
    marginBottom: "8px",
    flexWrap: "wrap",
  },
  fieldSearch: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: "var(--admin-gap-sm)",
    flex: "1 1 auto",
  },
  fieldSearchTitle: {
    margin: 0,
    color: "var(--text-muted)",
    fontSize: "var(--admin-text-xs)",
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  jsonQueryBlock: {
    marginBottom: "14px",
  },
  jsonQueryTextarea: {
    width: "100%",
    minHeight: "var(--admin-textarea-min-height)",
    padding: "var(--admin-control-padding-y) var(--admin-control-padding-x)",
    borderRadius: "var(--admin-radius)",
    border: "1px solid var(--border)",
    background: "var(--field-bg)",
    color: "var(--text-main)",
    fontSize: "var(--admin-text-sm)",
    lineHeight: 1.5,
    fontFamily: "Consolas, Monaco, monospace",
    boxSizing: "border-box",
    resize: "vertical",
    outline: "none",
  },
  filterError: {
    margin: "8px 0 0",
    color: "var(--danger)",
    fontSize: "var(--admin-text-sm)",
  },
  resultCount: {
    margin: 0,
    color: "var(--text-muted)",
    fontSize: "var(--admin-text-sm)",
    fontWeight: 700,
  },
  viewControls: {
    display: "flex",
    gap: "var(--admin-gap-sm)",
    alignItems: "center",
  },
  input: {
    width: "100%",
    minHeight: "var(--admin-control-height)",
    padding: "var(--admin-control-padding-y) var(--admin-control-padding-x)",
    borderRadius: "var(--admin-radius)",
    border: "1px solid var(--border-strong)",
    fontSize: "var(--admin-text)",
    boxSizing: "border-box",
    background: "var(--field-bg)",
    color: "var(--text-main)",
  },
  tableWrap: {
    minHeight: "100%",
    overflow: "visible",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "var(--admin-text)",
    tableLayout: "auto",
  },
  th: {
    textAlign: "left",
    verticalAlign: "middle",
    padding: "var(--admin-table-cell-y) var(--admin-table-cell-x)",
    borderBottom: "1px solid var(--border-strong)",
    color: "var(--text-muted)",
    fontSize: "var(--admin-text-xs)",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    position: "sticky",
    top: 0,
    zIndex: 2,
    background: "var(--card-bg-soft)",
  },
  td: {
    padding: "var(--admin-table-cell-y) var(--admin-table-cell-x)",
    borderBottom: "1px solid var(--border)",
    color: "var(--text-main)",
    verticalAlign: "middle",
    boxSizing: "border-box",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  nameCell: {
    width: "auto",
  },
  cityCell: {
    width: "auto",
  },
  typeCell: {
    width: "auto",
  },
  transferCell: {
    width: "auto",
  },
  statusCell: {
    width: "auto",
  },
  sipCell: {
    width: "auto",
  },
  developerCell: {
    width: "auto",
  },
  actionsCell: {
    whiteSpace: "nowrap",
  },
  actionsTd: {
    padding: "var(--admin-table-cell-y) 4px",
  },
  name: {
    fontWeight: 700,
  },
  muted: {
    color: "var(--text-muted)",
    fontSize: "var(--admin-text-sm)",
  },
  badge: {
    display: "inline-flex",
    padding: "var(--admin-badge-padding-y) var(--admin-badge-padding-x)",
    borderRadius: "999px",
    background: "var(--card-bg-soft)",
    color: "var(--text-main)",
    fontSize: "var(--admin-text-xs)",
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  activeBadge: {
    background: "var(--success-soft)",
    color: "var(--success)",
  },
  stopBadge: {
    background: "var(--danger-soft)",
    color: "var(--danger)",
  },
  button: {
    border: "none",
    background: "var(--accent)",
    color: "var(--button-text)",
    borderRadius: "var(--admin-radius)",
    padding: "var(--admin-button-padding-y) var(--admin-button-padding-x)",
    fontSize: "var(--admin-text-sm)",
    fontWeight: 700,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  actionsRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "var(--admin-gap-sm)",
  },
  tableActionsRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "3px",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  iconButton: {
    width: "var(--admin-icon-control-size)",
    height: "var(--admin-icon-control-size)",
    background: "var(--card-bg-soft)",
    color: "var(--text-main)",
    border: "1px solid var(--border)",
    borderRadius: "var(--admin-radius-sm)",
    padding: 0,
    fontSize: "var(--admin-text-sm)",
    fontWeight: 700,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
    flex: "0 0 auto",
  },
  editIconButton: {
    background: "var(--accent)",
  },
  copyIconButton: {
    background: "var(--card-bg-soft)",
  },
  cloneIconButton: {
    background: "var(--card-bg-soft)",
  },
  removeIconButton: {
    background: "var(--danger-soft)",
    color: "var(--danger)",
  },
  viewButton: {
    border: "1px solid var(--border-strong)",
    background: "var(--card-bg)",
    color: "var(--text-main)",
    borderRadius: "var(--admin-radius)",
    padding: "var(--admin-button-padding-y) var(--admin-button-padding-x)",
    fontSize: "var(--admin-text-sm)",
    fontWeight: 700,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  viewButtonActive: {
    borderColor: "var(--accent-border)",
    background: "var(--accent-soft)",
    color: "var(--text-main)",
  },
  paginationBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "var(--admin-gap)",
    flexWrap: "wrap",
  },
  jsonList: {
    display: "flex",
    flexDirection: "column",
    gap: "var(--admin-gap-lg)",
  },
  jsonCard: {
    border: "1px solid var(--border)",
    borderRadius: "12px",
    padding: "var(--admin-card-padding)",
    background: "var(--card-bg)",
  },
  jsonHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "var(--admin-gap-lg)",
    marginBottom: "10px",
  },
  modalOverlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(5, 10, 18, 0.72)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "var(--admin-modal-gutter)",
    zIndex: 4000,
  },
  bulkModal: {
    width: "min(var(--admin-modal-sm), calc(100vw - 2 * var(--admin-modal-gutter)))",
    maxHeight: "calc(100dvh - 2 * var(--admin-modal-gutter))",
    overflowY: "auto",
    background: "var(--header-bg)",
    borderRadius: "var(--admin-modal-radius)",
    boxShadow: "var(--shadow-panel)",
    border: "1px solid var(--border)",
    padding: "var(--admin-modal-padding)",
    boxSizing: "border-box",
  },
  bulkTextarea: {
    width: "100%",
    minHeight: "var(--admin-textarea-min-height)",
    padding: "var(--admin-control-padding-y) var(--admin-control-padding-x)",
    borderRadius: "var(--admin-radius)",
    border: "1px solid var(--border)",
    background: "var(--field-bg)",
    color: "var(--text-main)",
    fontSize: "var(--admin-text-sm)",
    lineHeight: 1.5,
    fontFamily: "Consolas, Monaco, monospace",
    boxSizing: "border-box",
    resize: "vertical",
    outline: "none",
  },
  pre: {
    margin: "12px 0 0",
    padding: "var(--admin-card-padding)",
    borderRadius: "var(--admin-radius)",
    background: "var(--field-bg)",
    color: "var(--text-main)",
    fontSize: "var(--admin-text-xs)",
    lineHeight: 1.5,
    overflowX: "auto",
    whiteSpace: "pre-wrap",
  },
  state: {
    padding: "var(--admin-card-padding)",
    color: "var(--text-muted)",
    textAlign: "center",
  },
  typeText: {
    display: "block",
    minWidth: 0,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
};
